export { default } from './InfoTooltip';
